<template>
  <div class="pageWarp">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

<!--    &lt;!&ndash; 黄色提示栏 &ndash;&gt;-->
<!--    <div :class="{'hide': hideTopYellowTips}" class="yellow_tips_box boxs flex_h_hL_vC">-->
<!--      <span class="info">未定！XXXXXXXXXXXXXXXXXXXXXXXX</span>-->
<!--      <img @click="hideTopYellowTips = true" class="icon_close_yellow"-->
<!--           src="@/assets/images/enjoy/yellowCloseIcon.png" alt="">-->
<!--    </div>-->


    <!-- 日期、月份筛选区 -->
    <div class="filter_box boxs flex_h_hL_vC">
      <div class="left_picker boxs flex_h ite-c">
        <el-date-picker
                v-model="dateValue"
                type="month"
                placeholder="选择年月日"
                value-format="yyyyMM"
                :clearable="false"
                @change="onDateChange"
        >
        </el-date-picker>
      </div>
    </div>

    <!-- 筛选框 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-input
                  v-model="searchForm.params.orderId"
                  placeholder="请输入订单号"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
                  v-model="searchForm.params.userName"
                  placeholder="请输入用户姓名"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input
                  v-model="searchForm.params.serviceTelphone"
                  placeholder="请输入开户号码"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

<!--        <el-form-item>-->
<!--          <el-select-->
<!--                    :value="searchForm.params.status"-->
<!--                     @change="onStatusChange"-->
<!--                     placeholder="请选择账单状态"-->
<!--                     size="medium" clearable-->
<!--                     filterable>-->
<!--            <el-option-->
<!--                    v-for="item in statusOptions"-->
<!--                    :key="item.key"-->
<!--                    :label="item.label"-->
<!--                    :value="item.key"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->

      </template>
    </sr-filter>

    <div class="summary_area boxs flex_h">
      <!-- 左边统计 -->
      <div @click="changeStatueEvent(0)" class="left_simple_block summary_block boxs flex_h_hC_vC">
        <span class="clamp_1">共查询到 {{stat.sumCount.counts}} 笔</span>
      </div>

      <div @click="changeStatueEvent(1)" class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>待核销</span>
          <span><small>{{stat.map1.counts}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.map1.sum_fee | centsToYuan}}</span> 元
        </div>
      </div>

      <div @click="changeStatueEvent(2)" class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>已核销（已缴费）</span>
          <span><small>{{stat.map2.counts}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.map2.sum_fee | centsToYuan}}</span> 元
        </div>
      </div>

      <div @click="changeStatueEvent(3)" class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>已核销（未缴费）</span>
          <span><small>{{stat.map3.counts}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.map3.sum_fee | centsToYuan}}</span> 元
        </div>
      </div>
      <div @click="changeStatueEvent(4)" class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>待解冻</span>
          <span><small>{{stat.map4.counts}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.map4.sum_fee | centsToYuan}}</span> 元
        </div>
      </div>
      <div @click="changeStatueEvent(5)" class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>已解冻</span>
          <span><small>{{stat.map5.counts}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.map5.sum_fee | centsToYuan}}</span> 元
        </div>
      </div>
      <div @click="changeStatueEvent(6)" class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>已违约</span>
          <span><small>{{stat.map6.counts}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.map6.sum_fee | centsToYuan}}</span> 元
        </div>
      </div>
      <div @click="changeStatueEvent(7)" class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>延期</span>
          <span><small>{{stat.map7.counts}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.map7.sum_fee | centsToYuan}}</span> 元
        </div>
      </div>
    </div>


    <!-- 表格 -->
    <div class="botTable boxs tableTheadGray">
      <div class="tableTop">
        <span class="top_le">分期账单列表</span>

<!--        <div class="btnGroup">-->
<!--          <button class="butStyle pinkBtn exportBtn" @click="tableExport">-->
<!--            <i class="exportIcon"></i>-->
<!--            <span>导出当前范围数据</span>-->
<!--          </button>-->

<!--          <button  style="margin-left: 20px" class="butStyle pinkBtn exportBtn" @click="tableExportAll">-->
<!--            <i class="exportIcon"></i>-->
<!--            <span>导出全部数据</span>-->
<!--          </button>-->
<!--        </div>-->
      </div>
      <el-table :data="tableData"
                size="small"
                style="width: 100%;"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
      >
        <el-table-column label="订单号" prop="order_id" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip >
          <template slot-scope="scope">
            <span class="blueT">{{scope.row.order_id}}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户" prop="user_name" min-width="12" header-align="center" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column label="开户号码" prop="service_telphone" min-width="12" header-align="center" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column label="账单月份" prop="bill_month" min-width="12" header-align="center" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column label="账单期数" prop="periods" min-width="12" header-align="center" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column label="应缴话费(元)" prop="monthly_phone_bill" min-width="12" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope" class="orangeText">
                      <span class="orangeText">
                              {{scope.row.monthly_phone_bill | centsToYuan}}
                        </span>
          </template>
        </el-table-column>
        <el-table-column label="应解冻款(元)" prop="wait_unfreeze_at" min-width="12" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope" class="orangeText">
                      <span class="orangeText">
                              {{scope.row.wait_unfreeze_at | centsToYuan}}
                        </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" min-width="12" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope" class="orangeText">
                                <span :class="{orangeT:scope.row.status==='1', lightGT:scope.row.status==='5'}">
<!--                                     // 状态，1：待核销、2：已核销（已缴费）、3：已核销（未缴费）、4：待解冻、5：已解冻、6：已违约、7：延期滞纳、8：已作废-->
                                    <template v-if="scope.row.status === 1">
                                        待核销
                                    </template>
                                    <template v-if="scope.row.status === 2">
                                        已核销（已缴费）
                                    </template>
                                    <template v-if="scope.row.status === 3">
                                        已核销（未缴费）
                                    </template>
                                    <template v-if="scope.row.status === 4">
                                        待解冻
                                    </template>
                                    <template v-if="scope.row.status === 5">
                                        已解冻
                                    </template>
                                    <template v-if="scope.row.status === 6">
                                        已违约
                                    </template>
                                    <template v-if="scope.row.status === 7">
                                        延期滞纳
                                    </template>
                                </span>
          </template>
        </el-table-column>
<!--        <el-table-column label="操作" fixed="right" min-width="12" header-align="center" align="left"-->
<!--                         show-overflow-tooltip>-->
<!--          <template slot-scope="scope">-->
<!--            <el-button @click="goDetailPage(scope)"-->
<!--                       class="greenT"-->
<!--                       icon="el-icon-search"-->
<!--                       type="text"-->
<!--                       title="详情">详情-->
<!--            </el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <div class="pageBox boxs">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';
  import {formatDate} from '@/utils/dateFormatter';
  import {getListAPI, getStatAPI} from '@/api/FillManage/fillManage';
  import {objectToQueryString} from '@/utils/commonUtils.js';

  const status = {
    '-1': {text: '申请中', cls: 'grayT'},
    '0': {text: '待核销', cls: 'orangeT'},
    '1': {text: '未支付', cls: 'grayT'},
    '2': {text: '已支付', cls: 'lightGT'},
  }


  //获取当前日期
  let getCurrDay = function () {
    let date = new Date();
    return formatDate(date, 'yyyyMM');
  }

  // 搜索表格的条件
  const searchConst = {
    current: 1, //当前页码
    size: 10, //每页条数
    params: {
      billMonth: getCurrDay(), //日期
      orderId: null, //订单号
      userName: null, //终端归属
      serviceTelphone: null, //账单方id
      status: null, //账单状态
    },
  }

  export default {
    data() {
      return {
        dateValue: new Date(),
        //标题
        topTitle: {
          title: '分期账单管理',
          subTit: ''
        },

        // 筛选数据-日期
        filterData: [],

        // 是否隐藏页面顶部提示信息
        hideTopYellowTips: false,

        // 表格搜索条件
        searchForm:  this.initSearchParams(),
        // 终端归属
        terminalOwnershipOptions: [
        ],
        // 账单方id
        advanceMoneyPlatformOptions: [
        ],
        // 账单状态 状态，1：待核销、2：已核销（已缴费）、3：已核销（未缴费）、4：待解冻、5：已解冻、6：已违约、7：延期滞纳、8：已作废
        statusOptions: [
          {key: 1, label: '待核销'},
          {key: 2, label: '已核销（已缴费）'},
          {key: 3, label: '已核销（未缴费）'},
          {key: 4, label: '待解冻'},
          {key: 5, label: '已解冻'},
          {key: 6, label: '已违约'},
          {key: 7, label: '延期滞纳'},
        ],

        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,
        // 日期时间选择器
        timePickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },

        stat: {
          "sumCount": {
            "counts": 0
          },
          "map3": {
            "sum_fee": 0.00,
            "counts": 0
          },
          "map2": {
            "sum_fee": 0.00,
            "counts": 0
          },
          "map1": {
            "sum_fee": 0.00,
            "counts": 0
          },
          "map7": {
            "sum_fee": 0.00,
            "counts": 0
          },
          "map6": {
            "sum_fee": 0.00,
            "counts": 0
          },
          "map5": {
            "sum_fee": 0.00,
            "counts": 0
          },
          "map4": {
            "sum_fee": 0.00,
            "counts": 0
          }
        }
      }
    },
    computed: {},
    components: {
      TitleBox,
      SrFilter,
    },
    created() {
      this.initSearchParams()
      this.getFilterData()
      this.loadList()
      this.getStat()
    },
    methods: {

      getStatusText(val) {
        return status[val] || {text: '未知', cls: 'grayT'}
      },
      onDateChange(value) {
        if (!value) {
          this.searchForm.params.billMonth = value || null
        }
        this.searchForm.params.billMonth = value || null
        this.handleSearch()
      },
      onStatusChange(value) {
        console.log(value)
        this.searchForm.params.status = value
        if (value == null || value == 'undefined' || value === '') {
          console.log(this.searchForm.params.status);
          this.searchForm.params.status = null
        }
        this.handleSearch()
      },

      // 点击切换订单状态
      changeStatueEvent(msg) {
        if (msg === 0) {
          this.searchForm.params.status =null;
        } else {
          this.searchForm.params.status =msg;
        }
        this.handleSearch()
      },
      tableExportAll() {
        const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}`;
        console.log(url)
        window.open(url, '_blank');
      },
      tableExport() {
        const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
        console.log(url)
        window.open(url, '_blank');
      },
      formatDefault: function (date) {
        return formatDate(date, 'yyyyMM');
      },

      getFilterData() {
        this.filterData = [
          {month: '5月', day: '25', dayOfTheWeek: '星期一', showIcon: '0'},
          {month: '5月', day: '24', dayOfTheWeek: '星期日', showIcon: '1'},
          {month: '5月', day: '23', dayOfTheWeek: '星期六', showIcon: '0'},
          {month: '5月', day: '22', dayOfTheWeek: '星期五', showIcon: '0'},
          {month: '5月', day: '21', dayOfTheWeek: '星期四', showIcon: '0'},
          {month: '5月', day: '20', dayOfTheWeek: '星期三', showIcon: '0'},
          {month: '5月', day: '19', dayOfTheWeek: '星期二', showIcon: '0'},
          {month: '5月', day: '18', dayOfTheWeek: '星期一', showIcon: '1'},
          {month: '5月', day: '17', dayOfTheWeek: '星期日', showIcon: '0'},
          {month: '5月', day: '16', dayOfTheWeek: '星期六', showIcon: '0'},
          {month: '5月', day: '15', dayOfTheWeek: '星期五', showIcon: '0'},
          {month: '5月', day: '14', dayOfTheWeek: '星期四', showIcon: '0'},
          {month: '5月', day: '13', dayOfTheWeek: '星期三', showIcon: '0'},
          {month: '5月', day: '12', dayOfTheWeek: '星期二', showIcon: '0'},
          {month: '5月', day: '11', dayOfTheWeek: '星期一', showIcon: '0'},
          {month: '5月', day: '10', dayOfTheWeek: '星期日', showIcon: '0'},
        ]
      },

      async getStat() {
        const {data} = await getStatAPI(this.searchForm.params)
        this.stat = data
        console.log(this.stat);
      },

      // 获取表格数据
      async loadList() {
        const {data} = await getListAPI(this.searchForm)
        this.tableData = data.records
        this.total = data.total
      },


      // 列表过滤查询
      handleSearch() {
        this.loadList()
        this.getStat()
      },
      initSearchParams() {
        return this.$deepClone(searchConst);
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        // this.searchForm.date = getCurrDay();
        this.searchForm = this.initSearchParams()
        this.dateValue=new Date();
        // 获取表格数据
        this.handleSearch()
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.loadList()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.loadList()
      },


      // 跳转到详情页
      goDetailPage(scope) {
        this.$router.push({
          path: '/tbs/fundManage/reducedFeeDetail',
          query: {
            orderId: scope.row.orderId
          }
        })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .greenT {
    color: #2DBAA5 !important;
  }

  .lightGT {
    color: #76C819 !important;
  }

  .orangeT {
    color: #FA6241 !important;
  }

  .grayT {
    color: #B7B2AF !important;
  }

  .blueT {
    color: #3289FF !important;
  }


  .pageWarp {
    height: calc(100vh - 88px);
  }

  // 黄色提示栏
  .pageWarp .yellow_tips_box {
    margin-top: 0px;
    width: 100%;
    min-height: 28px;
    padding: 6px 9px 6px 12px;
    background: #FFFAEB;
    border: 1px solid #FFC400;
    transition: all 0.3s ease;
  }

  .pageWarp .yellow_tips_box.hide {
    display: none;
    transition: all 0.3s ease;
  }

  .yellow_tips_box .info {
    width: calc(100% - 9.71px - 5px);
    line-height: 16px;
    color: #FFC400;
    font-size: 12px;
    margin-right: 5px;
  }

  .yellow_tips_box .icon_close_yellow {
    width: 9.71px;
    height: 9.71px;
  }


  // 日期、月份筛选区
  .pageWarp .filter_box {
    margin: 5px 0;
    width: 100%;
    height: 124px;
    padding: 30px 0;
    box-sizing: border-box;
    background: #ffffff;
  }

  .filter_box .left_picker {
    width: 205px;
    height: 100%;
    padding: 0 20px 0 12px;
    box-sizing: border-box;
    background: #ffffff;
    border-right: 1px solid #F8F8F8;
  }

  .filter_box ul.right_scroll {
    width: calc(100% - 205px);
    height: 100%;
    padding: 0 12px 0 16px;
    box-sizing: border-box;
    background: #ffffff;
  }

  .filter_box ul.right_scroll li {
    min-width: 46px;
    height: 100%;
    background: #bfd8f8;
  }

  .filter_box ul.right_scroll li:first-child {
    margin-left: 16px;
  }

  .filter_box ul.right_scroll li + li {
    margin-left: 40px;
  }

  .filter_box ul.right_scroll li .top {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #7F7F7F;
  }

  .filter_box ul.right_scroll li .circle_box {
    width: 46px;
    height: 46px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    border-radius: 50%;
    position: relative;
    background: #ffffff;
    color: #C5C5C5;
  }

  .filter_box ul.right_scroll li .circle_box.greenBg {
    background: #2DBAA5;
    color: #ffffff;
  }

  .filter_box ul.right_scroll li .circle_box.grayBg {
    background: #FAFAFA;
    color: #333333;
  }

  .filter_box ul.right_scroll li .circle_box .mainT {
    font-size: 20px;
  }

  .filter_box ul.right_scroll li .circle_box .botT {
    font-size: 10px;
    margin-top: 0px;
  }

  .filter_box ul.right_scroll li .warnIcon {
    position: absolute;
    right: 0;
    bottom: 0;

    width: 16px;
    height: 16px;
    background: url('../../../assets/images/enjoy/redWarnCircleIcon.png') no-repeat;
    background-size: 100% 100%;
  }


  // 筛选框
  .pageWarp .searchBox {
    margin-top: 0px;
  }


  // 总结
  .pageWarp .summary_area {
    flex-wrap: wrap;
  }

  .pageWarp .summary_block {
    margin-top: 12px;
    width: 207px;
    height: 72px;
    background: #fff;
    // border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 20px;
    font-size: 12px;
    color: #333333;
    white-space: nowrap;
    margin-right: 14px;
  }

  .pageWarp .summary_block .first_text {
    min-width: 160px;
    max-width: 100%;
    margin-bottom: 6px;
  }

  .pageWarp .summary_block .first_text small {
    color: #2DBAA5;
    margin-right: 3px;
  }

  .pageWarp .summary_block .second_text {
    // line-height: 16px;
    height: 20px;
  }

  .pageWarp .summary_block .second_text span.bigT {
    height: 20px;
    color: #FA6241;
    font-size: 20px;
    font-weight: normal;
    margin-right: 3px;
  }

  // 左边统计
  .pageWarp .summary_area .summary_block.left_simple_block {
    width: 141px;
    height: 72px;
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 0px;
    font-size: 12px;
    color: #333333;
    white-space: nowrap;
    margin-right: 14px;
  }


  // 表格
  .pageWarp .botTable {
    margin-top: 12px;
    width: 100%;
    // max-height: 408px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .exportBtn {
    padding: 5px;
    /*width: 72px;*/
    height: 30px;
    /*line-height: 30px;*/
    font-size: 13px;
    border-radius: 4px;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }


</style>

